
import { supabase } from "@/integrations/supabase/client";

export const updateCampaignPaymentType = async (campaignId: string) => {
  const dueDate = new Date();
  dueDate.setDate(dueDate.getDate() + 60);

  const { error } = await supabase
    .from('campaigns')
    .update({
      payment_type: 'bank_transfer',
      bank_transfer_due_date: dueDate.toISOString(),
      bank_transfer_status: 'pending',
      status: 'pending' // Keep campaign as pending until payment is verified
    })
    .eq('id', campaignId);

  return { error };
};

export const verifyCreditCardPayment = async (paymentId: string) => {
  console.log('Verifying credit card payment:', paymentId);
  
  const { data, error } = await supabase.functions
    .invoke('verify-moyasar-payment', {
      body: { payment_id: paymentId }
    });

  if (error) {
    console.error('Payment verification error:', error);
    return { verified: false, error };
  }

  if (!data || (data.status !== 'paid' && data.status !== 'authorized')) {
    console.error('Payment not confirmed:', data);
    return { verified: false, error: 'Payment not confirmed' };
  }

  console.log('Payment verified successfully:', data);
  return { verified: true, data };
};

export const markCampaignAsPaid = async (campaignId: string, paymentReference?: string) => {
  const { error } = await supabase
    .from('campaigns')
    .update({
      status: 'approved',
      bank_transfer_status: 'approved',
      payment_verified_at: new Date().toISOString(),
      payment_reference: paymentReference || null
    })
    .eq('id', campaignId);

  return { error };
};
